export const LinksKeys = {
    TermsAndCondition: 'https://help.ableapp.com/en/articles/5590061-eula',
    PrivacyPolicy: 'https://ableapp.com/privacy-policy',
    RefundPolicy: 'https://help.ableapp.com/hc/able/articles/1694789184-refund-policy'
};
